import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import RichText from '@components/atoms/RichText';
import Link from '@components/atoms/Link';
import HeaderFont from '@components/atoms/HeaderFont';
import { dataLayerClick } from '@helpers/dataLayerPush';

const SimpleContentBlock = ({ data: { content, buttonText, buttonLink } }) => {
  return (
    <Wrapper narrow>
      <Box pb={{ base: `14`, md: `16` }}>
        <Box>
          <RichText data={content.data.content} />
        </Box>
        {buttonText && buttonText.length > 0 && (
          <Flex justifyContent="center" mt="4">
            <Link
              textAlign={{ base: `center`, md: `auto` }}
              href={buttonLink}
              variant="purpleButton"
              fontSize="md"
              width={{ base: `100%`, sm: `auto` }}
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: buttonText,
                  clickUrl: buttonLink
                });
              }}>
              <HeaderFont>{buttonText}</HeaderFont>
            </Link>
          </Flex>
        )}
      </Box>
    </Wrapper>
  );
};

export default SimpleContentBlock;
